export const frPrel_V1_0_0_StaticFilesIds = ['fr-prel-v1_0_0-general-terms', 'fr-prel-v1_0_0-ipid'] as const
